import React from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';
import moment from 'moment';

const {
	func, shape, string, bool, arrayOf
} = propTypes;

function Day ({
	date, timeSlots, isCurrentMonth, isSelected, isToday, onSelectDate
}) {
	const id = `choose-day-${date.replace('.', '').replace(/:/g, '')}`;

	const tdClassNames = classnames({
		'current-month': isCurrentMonth,
		'day': true,
		'selectable': timeSlots.length && isCurrentMonth
	});

	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			onSelectDate(date);
		}
	};

	let wrapperClassNames = classnames({
		'day-wrapper': true,
		'selected': isSelected,
		'current-day': isToday
	});

	return (
		<td className={tdClassNames}>
			<div className={wrapperClassNames} tabIndex={timeSlots.length ? 0 : -1} onKeyDown={(e) => handleKeyPress(e)} role='button'>
				<label className='day' htmlFor={id}>
					{moment.utc(date).format('D')}
					<input
						id={id}
						aria-label={date}
						type='radio'
						name='calendar'
						onChange={() => onSelectDate(date)}
						disabled={!timeSlots.length || isSelected || !isCurrentMonth}
					/>
				</label>
			</div>
			{timeSlots.length ? <span className='availability' /> : null}
		</td>
	);
}

Day.propTypes = {
	date: string.isRequired,
	timeSlots: arrayOf(shape({
		startDatetime: string.isRequired,
		endDatetime: string.isRequired
	})),
	isCurrentMonth: bool,
	isSelected: bool,
	isToday: bool,
	onSelectDate: func.isRequired
};

export default Day;
